/** @file artKeyHandlers: the handler table for `artBindings` over the visible slots and the selection. */
import type { ArtSlot } from './artTypes';
import { nextSlot } from './nextSlot';

/** What the keys act on: the part's slots, the selected key, and the screen's operations. */
export type ArtKeyContext = {
  slots: readonly ArtSlot[]; selected: string | null;
  select: (key: string) => void; clear: (key: string) => void; upload: () => void; mask: (key: string) => void;
};

/** One handler per `artBindings` id; keys needing a selection do nothing without one. */
export function artKeyHandlers(ctx: ArtKeyContext): Record<string, () => void> {
  const move = (step: 'left' | 'right' | 'up' | 'down') => (): void => {
    const key = nextSlot(ctx.slots, ctx.selected, step);
    if (key !== null && key !== ctx.selected) ctx.select(key);
  };
  const withSelected = (f: (key: string) => void) => (): void => { if (ctx.selected !== null) f(ctx.selected); };
  return {
    'art.selectLeft': move('left'),
    'art.selectRight': move('right'),
    'art.selectUp': move('up'),
    'art.selectDown': move('down'),
    'art.clearSlot': withSelected(ctx.clear),
    'art.upload': withSelected(() => { ctx.upload(); }),
    'art.downloadMask': withSelected(ctx.mask),
  };
}
